<div class="row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="page-head xs-mt-15">
        <h3 class="d-flex align-items-center">Seed Returns <i [ngClass]="{'all-icon': (selectedProductLineText == 'All'), 'corn-icon': (selectedProductLineText == 'Corn'), 'alfa-icon': (selectedProductLineText == 'Alfalfa'), 'cotton-icon': (selectedProductLineText == 'Cotton'), 'canola-icon': (selectedProductLineText == 'Spring Canola' || selectedProductLineText == 'Winter Canola'),  'sorghum-icon': (selectedProductLineText == 'Forage Sorghum' || selectedProductLineText == 'Grain Sorghum' ), 'sunflower-icon': (selectedProductLineText == 'Sunflower')}" class="xs-ml-10 xs-mr-10 light-weight"></i><span>{{selectedProductLineText}}</span></h3>
        <p>Filter return request by choosing the type of the filter you'd like to use and searching for a value. You may opt to view submitted returns on the tab below, or see your saved drafts by selecting return request drafts tab.</p>
      </div>
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/seed-returns-dashboard/{{seedReturnService.dashboardSelectedProductLine}}">Seed Return</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{selectedProductLineText}}</span>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span id="spnBreadcrum">{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="returnTop xs-mb-5">
        <div *ngIf="createRequestAccess">
          <div class="row">
            <div class=" col-lg-3 col-md-6 material-select withBordr required">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || readOnlyAccess"
                         bindValue="accountNumber"
                         placeholder="Account:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div>
                          Account #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6 required-input-field">
              <mat-form-field class="wide100">
                <input [disabled]="isEditMode || readOnlyAccess || showSubmitToJde" readonly matInput type=text name="dsm"
                       placeholder="SDM :"
                       autocomplete="new-username"
                       [(ngModel)]="dsmInfo"
                       value="dsmInfo" />
              </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-6 required-input-field" *ngIf="isShowNonSubEmail">
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Non-Subscriber Email:</mat-label>
                <input matInput type="email" name="accountEmail"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [(ngModel)]="accountEmail"
                       [readonly]="readOnlyAccess"
                       [disabled]="showSubmitToJde"
                       [pattern]="emailPattern"
                       (keyup)="validateEmail()"
                       (input)="hasEmailAddressChanged();"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="return-period-not-valid-block text-center xs-mt-50" *ngIf="shipToAccount && !isReturnPeriodValid">
        <p><strong>{{returnPeriodNotValidMessage}}</strong></p>
      </div>

      <div *ngIf="!shipToAccount || isReturnPeriodValid">
      <div class="returnTop xs-mb-5">
        <div class="row">
          <div class="col-md-4">
            <span class="font-16">
              I have product(s) to return:*
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group">
                Yes <mat-radio-button id="rdProductYes" class="custom-radio" [disabled]="isDisableRdButtons" value="true" [checked]="rdProduct" (change)="changeProductRd(true)"></mat-radio-button>
                No <mat-radio-button id="rdProductNo" class="custom-radio" [disabled]="isDisableRdButtons" value="false" [checked]="rdProduct===false" (change)="changeProductRd(false)"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
          <div class="col-md-4" *ngIf="emptyPallet === 'Y'">
            <span class="font-16">
              I have empty pallet(s) to return:{{mandatoryFieldSymbol}}
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group">
                Yes <mat-radio-button id="rdEmptyPalletYes" class="custom-radio" [disabled]="isDisableRdButtons" value="true" [checked]="rdEmptyPallet" (change)="changeEmptyPalletRd(true)"></mat-radio-button>
                No <mat-radio-button id="rdEmptyPalletNo" class="custom-radio" [disabled]="isDisableRdButtons" value="false" [checked]="rdEmptyPallet===false" (change)="changeEmptyPalletRd(false)"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
          <div class="col-md-4" *ngIf="emptyCBox === 'Y'">
            <span class="font-16">
              I have empty CBox(s) to return:{{mandatoryFieldSymbol}}
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group">
                Yes <mat-radio-button id="rdEmptyCBoxYes" class="custom-radio" [disabled]="isDisableRdButtons" value="true" [checked]="rdEmptyCBox" (change)="changeEmptyCBoxRd(true)"></mat-radio-button>
                No <mat-radio-button id="rdEmptyCBoxNo" class="custom-radio" [disabled]="isDisableRdButtons" value="false" [checked]="rdEmptyCBox===false" (change)="changeEmptyCBoxRd(false)"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
        </div>
      </div>

      <!--Pickup Information Section-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0">
          Pickup Information: <span class="verbiage xs-ml-5 flex-one">(*Required)</span> <span (click)="togglePickup()" class="xs-expand-none xs-mr-20"
                                                                                               [ngClass]="!isAddProductEnable ? 'disabled-icon' : ' '">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpanded ? 'collapsed' : 'expanded'">
          <div class="col-lg-2 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field">
              <mat-form-field>
                <mat-label>Desired Pickup Date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="desiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" [disabled]="showSubmitToJde"
                       required (change)="desiredPickupDateValid(dateName)">
                <mat-datepicker-toggle id="datepickerToggle" matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Name :</mat-label>
                <input matInput type="text"
                       name="ContactName"
                       autocomplete="new-username"
                       [(ngModel)]="contactName"
                       maxlength="15"
                       required
                       #name="ngModel"
                       (change)="nameShouldBeValid(name)"
                       [disabled]="showSubmitToJde" />
              </mat-form-field>
            </div>
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Number :</mat-label>
                <input matInput type=text name="ContactNumber"
                       autocomplete="new-username"
                       [(ngModel)]="contactNumber"
                       required
                       mask="000-000-0000"
                       #phone="ngModel"
                       (change)="phoneShouldBeValid(phone)"
                       [disabled]="showSubmitToJde" />
                <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class="not-required-input">
              
              <mat-form-field class="wide100">
                <mat-label>Customer PO Number :</mat-label>
                <input matInput type=text name="CustomerPONumber"
                       autocomplete="new-username"
                       [(ngModel)]="customerPONumber"
                       maxlength="25" />
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr not-required-select">
            <ng-select name="ddlPickupLocation"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="deliveryAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Pickup Location: (if different than account)"
                       [loading]="shipToDataLoading" [closeOnSelect]="true" [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>

            <mat-form-field class="example-full-width specialInst">
              <label class="checkbox-color">Shipping Instructions:</label>
              <textarea style="resize:none;height:auto;" matInput rows="6" id="txtShippingInstructions"
                        [(ngModel)]="shippingInstructions"
                        [maxLength]="500"
                        [readonly]="readOnlyAccess"
                        [disabled]="showSubmitToJde"></textarea>
            </mat-form-field>
          </div>
          <div class=" col-lg-4 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction" [value]="item">
                    {{item.value}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-md-4 xs-pl-15 required-input-field" matTooltip="Auto Calculated Based on Quantity to be Returned"
                   [matTooltipPosition]="'above'" matTooltipClass='black-tooltip' *ngIf="rdProduct">
                <mat-form-field class="wide100">
                  <mat-label>Pallet Count :</mat-label>
                  <input matInput type="text" name="PalletCount"
                         autocomplete="new-username"
                         [(ngModel)]="palletCount"
                         required
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count="ngModel"
                         [readonly]="true"
                         (change)="countShouldBeValid(count)" />
                  <!--<mat-error *ngIf="count.invalid && (count.dirty || count.touched)">Please enter the number of pallets being returned</mat-error>-->
                </mat-form-field>
              </div>
              <div class="col-md-4 pl-3 xs-pr-10 required-input-field" *ngIf="rdEmptyPallet">
                <mat-form-field class="wide100">
                  <mat-label>Empty Pallet Count :</mat-label>
                  <input matInput type="text" name="EmptyPalletCount"
                         autocomplete="new-username"
                         required
                         [(ngModel)]="emptyPalletCount"
                         [disabled]="showSubmitToJde"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');" />
                </mat-form-field>
              </div>
              <div class="col-md-4 pl-3 required-input-field" *ngIf="rdEmptyCBox">
                <mat-form-field class="wide100">
                  <mat-label>Empty CBox Count :</mat-label>
                  <input matInput type="text" name="EmptyCBoxCount"
                         autocomplete="new-username"
                         required
                         [(ngModel)]="emptyBoxCount"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">

          <div class="grower-add-sec seed-return-filter">
            <div *ngIf="!readOnlyAccess" class="row listing-action-items grower-page">
              <div class="col-lg-8 col-md-9">
                <mat-checkbox *ngIf="isAddProductEnable && productAllDataSource?.filteredData?.length > 0" #AllProductCheck class="custom-checkbox select-all-check"
                              [checked]="isAllProductChecked"
                              [style.display]="disablecheckbox ? 'none' : 'block'"
                              [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                              (change)="enableAllCheckBoxes(!isAllProductChecked)"
                              title="Select All Lines"></mat-checkbox>
                <div class="product-filter-outer">
                  <div class="product-filter col-md-12" *ngIf="!editToolKit || checkBoxCount<=0 || isSearchClicked">
                    <div class="search-category">
                      <div class="brand-dropdown default-select">
                        <ng-select [disabled]="readOnlyAccess" [items]="searchTypeList"
                                   name="ddlProductSearch"
                                   [(ngModel)]="productSearchFilter"
                                   [virtualScroll]="true"
                                   [closeOnSelect]="true"
                                   [selectOnTab]="true"
                                   [clearable]="false"
                                   bindLabel="name"
                                   bindValue="value"
                                   [searchable]="false"
                                   (change)="keepFilter()"
                                   placeholder="Select Category">
                        </ng-select>
                      </div>
                    </div>
                    <div class="search-box">
                      <div class="row margin-0">
                        <div class="default-select select-container">

                          <div *ngIf="productSearchFilter === 'productName'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectProductName($event)" [(ngModel)]="productFilters.productName" placeholder="Search">
                              </div>
                            </div>
                          </div>

                          <ng-select #marketingBrand name="ddlMarketingBrandSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                     [items]="marketingBrandMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.marketingBrand"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #packageSize name="ddlpackageSizeSearch" *ngIf="productSearchFilter === 'packageSize'"
                                     [items]="packageSizeMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.packageSize"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #packageSize name="ddlseedSizeSearch" *ngIf="productSearchFilter === 'seedSize'"
                                     [items]="seedSizeMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.seedSize"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <div *ngIf="productSearchFilter === 'technology'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectTechnology($event)" [(ngModel)]="productFilters.technology" placeholder="Search">
                              </div>
                            </div>
                          </div>
                          <ng-select #treatment name="ddlTreatmentSearch" *ngIf="productSearchFilter === 'treatmentDescription'"
                                     [items]="treatmentMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.treatmentDescription"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'itemNumber'"
                                     [items]="invoicedProductList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.invoicedProductList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'invoiceNumber'"
                                     [items]="invoiceNumberList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.invoiceNumberList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'lotNumber'"
                                     [items]="lotNumberList"
                                     placeholder="Search"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     class="custom-select-grower"
                                     [(ngModel)]="productFilters.lotNumberList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #statusSearch name="ddlStatusSearch" *ngIf="productSearchFilter === 'status'"
                                     [items]="statusList"
                                     placeholder="Search"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     class="custom-select-grower"
                                     [(ngModel)]="productFilters.status"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row chips-sec" *ngIf="(!editToolKit || checkBoxCount<=0 || isSearchClicked) && filterValueList != ''">
                    <div class="col-sm-9 col-md-10 selected-chip">
                      <div>
                        <mat-chip-set>
                          <mat-chip selected *ngFor="let filterValue of filterValueList">
                            {{filterValue}}
                            <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                              <i class="fas fa-times text-right"></i>
                            </a>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>
                    <div class="col-sm-3 col-md-2 text-right">

                      <a href="Javascript:void(0);" *ngIf="filterValueList.length > 0" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                    </div>
                  </div>
                </div>

                <div class="product-tools-tab" *ngIf="showTabs && (!isSearchClicked && editToolKit)" appClickOutside (clickOutside)="tabNode=''">
                  <div class="tab-bar">
                    <ul>
                      <li *ngIf="(isValidLineStatus && !readOnlyAccess)" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Products" [matTooltipPosition]="'above'">
                        <i class="icon-ico-trash"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div *ngIf="tabNode==='delete'" class="delete-product">
                      <div class="tab-content-heading">
                        For: {{selectedAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                        <div class="btn-area">
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-3 text-right">
                <div class="row">
                  <div class="col-md-2 text-left padding-l0">
                    <ul class="padding-t10">
                      <li *ngIf="checkBoxCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                        <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-10 text-center">
                    <button id="btnAddProduct" mat-raised-button class="btns" [disabled]="!isAddProductEnable" *ngIf="(!readOnlyAccess)" (click)="addProduct()">Add Product</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 margin-t10">
              <div class="productTableOuter">
                <div class="tableContainer prodTableContainer" id="returnRequestView">
                  <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                </div>
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Item Number</th></div>
                <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
                <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
                <div *ngIf="column=='units'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
                <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Requested Units</th></div>
                <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
                <td mat-cell *matCellDef="let element">

                  <div *ngIf="column=='checkbox'">
                    <div *ngIf="requestStatus!='DRAFT'" [ngClass]="{ 'lineitem-error': element.lineStatus =='ERROR'}" class="lineitem-symbols"></div>
                  </div>
                  <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center CheckBoxCol" matTooltip="Select Product" [matTooltipPosition]="'above'">

                    <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                                  [(ngModel)]="element.isSelected"
                                  class="custom-checkbox"></mat-checkbox>
                  </div>
                  <div *ngIf="column=='product'" class="order-info-outer">
                    <div class="order-info">
                      <p class="prod-id">{{element.itemVendorName}}</p>
                      <p class="prod-name">{{element.itemDescription}}</p>
                    </div>
                  </div>
                  <div *ngIf="column=='itemNumber'" class="measureUnit text-center">
                    <p> {{element.itemNumber}} </p>
                  </div>
                  <div *ngIf="column=='lotNumber'" class="measureUnit text-center">
                    <p> {{element.lotNumber}} </p>
                  </div>
                  <div *ngIf="column=='uom'" class="measureUnit text-center">
                    <p> {{element.uom}} </p>
                  </div>
                  <div *ngIf="column=='units'" class="measureUnit text-center">
                    <p *ngIf="element.isManualLine" class="handCursor greyBg" matTooltipClass="toolTip" matTooltip="This is a manually added item." [matTooltipPosition]="'above'"> N/A </p>
                    <p *ngIf="!element.isManualLine"> {{element.eligibleUnit}} </p>
                  </div>
                  <div *ngIf="column=='dumpedUnits'" class="quantityBlock text-center">
                    <div>
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element)"> - </button>
                      <input id="txtRequestedQty_{{element.itemNumber}}" [readonly]="readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.returnQuantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element)"> + </button>
                    </div>
                  </div>

                  <div *ngIf="column=='seeds'" class="measureUnit text-center">
                    <p> {{element.seedPerPound}} </p>
                  </div>
                  <div *ngIf="column=='notes'" class="measureUnit text-center">
                    <textarea *ngIf="showSubmitToJde == false" id="txtRequestorNotes_{{element.itemNumber}}" [readonly]="readOnlyAccess" type="text" class="notesTxt" [(ngModel)]="element.requestorNotes" maxlength="250" (input)="hasNotesChanged(element.requestorNotes);"></textarea>
                    <p *ngIf="showSubmitToJde == true"> {{element.requestorNotes}} </p>
                  </div>
                </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="error-list">
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!--Error section on table-->
    <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
      <div class="row">
        <div class="col-md-2 padding-r0 errCountOuter">
          <span class="errorCounting">
            {{currentErrorRow}} of {{errorMsgs.length}}
          </span>
        </div>
        <div class="col-md-6 padding-l0 ">
          <ul class="errorMsg">
            <li *ngFor="let err of errorMsgs[index].errors">
              <p> {{err.error}}</p>
            </li>
          </ul>
        </div>

        <div class="col-md-4 button-sec text-right">
          <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
        </div>
      </div>
    </div>
    <div class="SeedFulfillBtnSec">
      <div class="row padding-l20">
        <div class="col-md-6">
          <button mat-raised-button class="btns" *ngIf="!readOnlyAccess && showSubmitReturn" [disabled]="isDisableSubmitRequestBtn()" (click)="saveDraft(true)" [style.display]="'inline-block'" id="btnReviewRequest">Review Request</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="!readOnlyAccess && showSubmitReturn" [disabled]="isDisableSaveDraftBtn()" (click)="saveDraft(false)" [style.display]="'inline-block'" id="btnSaveDraft">Save Draft</button>
        </div>
        <div class="col-md-6 text-right" *ngIf="chatAccess">
          <span class="count" style="margin-right: 50px;">Returnable Products <span style="margin-right: 20px;">{{selectedCount}}</span></span>
        </div>
        <div class="col-md-6 text-right" *ngIf="!chatAccess">
          <span class="count">Returnable Products <span>{{selectedCount}}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
